define('project/MbiGoogleMaps',[
    'jquery',
    'project/MbiConfig',
    'base/MbiHelper',
    'base/MbiMediaQuery',
    'base/Vendor/Async!https://maps.googleapis.com/maps/api/js?key=AIzaSyBJiBmY3k9jO44Gcfmr7klpAxczsYtJ7bQ'
        //'base/Vendor/Async!https://maps.googleapis.com/maps/api/js?key=AIzaSyCRWGo1uF5BSq_6M7taM-d5RqAkQRRn8mU'
], function(
    $,
    mbiConfig,
    _,
    mbiMq
) {
    'use strict';
    
   

    var module = {

        map:            {},
        mapOptions:     {},
        extraOptions:   {},

        markers:        [], // to store all the markers in order to manipulate
        infoWindows:    [],
        maps:           [], 

        /**
         * Initialization:
         * @param {locations}: json data/array for locations json
         *
         * @todo: maybe $.extend basic array with args
         */
        setMapOptions: function(args) {

            var ready = null;
            var styles = [
                    {
                        "stylers": [
                            { "saturation": -28 },
                            { "lightness": 17 },
                            { "hue": "#ffd500" },
                            { "gamma": 1.09 }
                        ]
                    },
                    {
                        "featureType": "water",
                        "stylers": [
                            { "hue": "#00ccff" },
                            { "saturation": -5 }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "stylers": [
                            { "hue": "#55ff00" }
                        ]
                    },
                    {
                        "elementType": "labels",
                        "stylers": [
                            { "saturation": -77 }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "stylers": [
                            { "lightness": 100 }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            { "lightness": -49 }
                        ]
                    },

                    {
                        "featureType": "poi.school",
                        "stylers": [
                            { "saturation": -59 }
                        ]
                    },
                    {
                        "stylers": [
                            { "saturation": -17 }
                        ]
                    }
                ];
 
            var center = new google.maps.LatLng(47.0873128, 15.2623986);

            module.mapOptions = {
                zoom: 11,
                center: center,
                scrollwheel: false,
                navigationControl: true,
                mapTypeControl: true,
                scaleControl: true,
                panControl: true,
                streetViewControl: true,
                zoomControl: false,
                draggable: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: styles
            };
            // GoogleMaps options
            if (typeof args.mapOptions !== "undefined") {

                if (args.mapOptions.mapTypeId !== "undefined")
                {

                    switch (args.mapOptions.mapTypeId) {

                        case "SATELLITE":
                            args.mapOptions.mapTypeId = google.maps.MapTypeId.SATELLITE;
                            break;
                        case "HYBRID":
                            args.mapOptions.mapTypeId = google.maps.MapTypeId.HYBRID;
                            break;
                        default:
                            args.mapOptions.mapTypeId = google.maps.MapTypeId.ROADMAP;
                            break;
                    }

                }

                if (args.center != "undefined")
                {
                    args.mapOptions.center = new google.maps.LatLng(args.center.latitude, args.center.langtitude);
                }


                $.extend(module.mapOptions , args.mapOptions);
               

            }

            module.extraOptions = {

                mapCanvasID: "map", //canvas container id
                markerIconUrl: "./Images/marker.png",
                markerIconWidth: 35,
                markerIconHeight: 51,
                markerCurrentLocationIconUrl: "./Images/marker_you_small.png",
                markerCurrentLocationIconWidth: 50,
                markerCurrentLocationIconHeight: 65,
                markerPath: 'CIRCLE', 
                maxZoomIn: 18,
                maxZoomOut: 12


            }

            if (typeof args.extraOptions !== "undefined") {

                $.extend(module.extraOptions, args.extraOptions);

            }


        },
        init: function(args) {
            module.setMapOptions(args);
            google.maps.event.addDomListener(window, 'load', module.googleMapInitialize(module.extraOptions.mapCanvasID));


        },

        // google map initialization
        googleMapInitialize: function(mapCanvasID) {
            
           
            module.maps[mapCanvasID] = new google.maps.Map(document.getElementById(mapCanvasID), module.mapOptions);
            module.map = module.maps[mapCanvasID];
            // on touch devices disable map drag to enable scroll of page
            if (Modernizr.touch) {
                module.setOptions({
                    draggable: true
                });
            }
            
            // resize handler
            google.maps.event.addDomListener(window, 'resize', function() {

                var center = module.maps[mapCanvasID].getCenter();
                google.maps.event.trigger(module.maps[mapCanvasID], 'resize');
                module.maps[mapCanvasID].setCenter(center);

            });

            
        },

        // set a google map marker icon
        getGoogleMapMarkerIcon: function(url, width, height) {
            var scale = 1;
            if ($('html').hasClass('ios')) {
                scale=2;
            }

            var icon = {
                url:        url,
                size:       new google.maps.Size(width, height),
                origin:     new google.maps.Point(0, 0),
                anchor:     new google.maps.Point(0, height),
                scaledSize: new google.maps.Size(width/scale, height/scale),
                optimized: false
            };

            return icon;

        },

        //set a google map marker Icon with SVG path
        getGoogleMapMarkerIconWithPath: function(path) {
            // path can be google.maps.SymbolPath.

            switch (path) {
                case "CIRCLE":
                    path = google.maps.SymbolPath.CIRCLE;
                    break;
                case "BACKWARD_CLOSED_ARROW":
                    path = google.maps.SymbolPath.BACKWARD_CLOSED_ARROW;
                    break;
                case "BACKWARD_OPEN_ARROW":
                    path = google.maps.SymbolPath.BACKWARD_OPEN_ARROW;
                    break;
                case "FORWARD_CLOSED_ARROW":
                    path = google.maps.SymbolPath.FORWARD_CLOSED_ARROW;
                    break;
                case "FORWARD_OPEN_ARROW":
                    path = google.maps.SymbolPath.FORWARD_OPEN_ARROW;
                    break;
                default:
                    break;
            }

            var icon = {
                path: path,                
                fillColor: '#FF0000', //customizable
                fillOpacity: .6,
                anchor: new google.maps.Point(0,0),
                strokeWeight: 0,
                scale: 1,
                optimized: false

            };
            return icon;
        },

        //create a google map marker for a location
        createGoogleMapMarker: function(icon, lat, lng) {

            var marker = new google.maps.Marker({

                position: new google.maps.LatLng(lat, lng),
                map: module.map,
                icon: icon

            });
            //module.map.setCenter(google.maps.LatLng(lat, lng));
            return marker;

        },
        createGoogleMapMarkerNew: function(canvasID,icon, lat, lng) {
            var latlng = new google.maps.LatLng(lat, lng);

            var marker = new google.maps.Marker({

                position: latlng,
                map: module.maps[canvasID],
                icon: icon

            });
            //module.maps[canvasID].panTo(latlng);
            return marker;

        },
        createLotionMarkerAndInfoWindow: function(address) {

            var infoWindow = new google.maps.InfoWindow({
                    closeBoxURL: "",
                });

            var content = module.setInfoWindowContent(address);

            var infoWindowItem = {
                infoWindow: infoWindow,
                address: address
            };

            infoWindow.setContent(content);
            google.maps.event.addListener(infoWindow, 'closeclick', function() {

                module.map.setZoom(module.mapOptions.zoom);

            });

            module.infoWindows.push(infoWindowItem);

            var marker = module.createLocationMarker(address);

            
            google.maps.event.addListener(marker, 'click', function() {

                module.closeAllInfoWindows();
                infoWindow.open(module.map, marker);
                module.extraOptions.markerClickCallback(this, address);

            });



        },

        closeAllInfoWindows: function() {

            $.each(module.infoWindows,function(key,item) {
                item.infoWindow.close(module.map, module.markers[key].marker);
            });

        },

        createLocationMarker: function(canvasID,address) {

            var lat = address['lat'],
                lng = address['lng'],
                icon = module.getGoogleMapMarkerIcon(module.extraOptions.markerIconUrl, module.extraOptions.markerIconWidth, module.extraOptions.markerIconHeight),
                marker = module.createGoogleMapMarkerNew(canvasID,icon, lat, lng),
                markerItem = {
                    elementID: address["elementID"],
                    marker: marker
                };

            return marker;

        },

        markerClickHandler: function(marker, address) {

            module.map.setZoom(14);
            module.map.panTo(marker.getPosition());
            module.extraOptions.markerClickCallback(this, address);

        },

        setInfoWindowContent: function(address) {
//console.log(address);
            var content = '<div class="infoWindow">'
                        + '<div class="name">' + address['name'] +'</div>'
                        + '<div class="address">' + address['address'] +'</div>';
            if(address['tel'] !== null && address['tel'].length > 0) {
                var phoneTel = address['tel'].replace(" ", "");
                phoneTel = phoneTel.replace("-", "");
                content += '<div class="telphone">' + '<a href="tel:'+ phoneTel+'">T ' + address['tel']+ '</a></div>';
            }
            content += '<div class="email">' + '<a href="mailto:'+ address['email']+'">' + address['email']+ '</a></div>';
            if (address['website'] !== null && address['website'].length > 0) {
                content = content + '<div class="website">' + '<a href="http://'+ address['website']+'" target="_blank">' + address['website']+ '</a></div>';
            }

            //var addrLink = 'https://www.google.at/maps/@'+address['lat']+','+address['lng'];
            var nameString = address['name'].trim();
            nameString = nameString.split(" ").join("+");

            var streetString = address['street'].trim();
            streetString = streetString.split(" ").join("+");
            streetString = streetString.trim();

            var cityString = address['city'].trim();
            cityString = cityString.split(" ").join("+");

            var postCodeString = address['postcode'].trim();
            postCodeString = postCodeString.split(" ").join("+");

var addrLink = 'http://maps.apple.com/?daddr='+encodeURI(streetString)+','+encodeURI(postCodeString)+'+'+encodeURI(cityString)+'&ll='+address['lat']+','+address['lng']+'&z=15';//?hl=de




            //var routeplan ='<div class="routeplan -landscape+">';
            var routeplan ='<div class="routeplan">';
            routeplan += '<a href="';
            routeplan += addrLink;
            routeplan += '" target="_blank">Google Maps Route</a></div>';
            content = content + routeplan +  '</div>';

            return content;

        },



        createAllLocationsMarkAndInfowindow: function() {

            $.each(module.extraOptions.locations,function(key,address) {

                module.createLotionMarkerAndInfoWindow(address);

            });

        },

        createAllLocationsMark: function() {

            $.each(module.extraOptions.locations,function(key,address) {

                module.createLocationMarker(address);

            });

        },

        showLocation: function(position) {

            var latitude = position.coords.latitude;
            var longitude = position.coords.longitude;

            var icon = module.getGoogleMapMarkerIcon(module.extraOptions.markerCurrentLocationIconUrl, module.extraOptions.markerCurrentLocationIconWidth,  module.extraOptions.markerCurrentLocationIconHeight);

            var marker = module.createGoogleMapMarker(icon,latitude, longitude);
            module.map.panTo(marker.getPosition());

        },

        // @todo: I18N this
        // @todo: "better error message popup whatever"
        errorHandler: function(err) {

            if(err.code == 1) {

                error = true;
                alert(err[0]);
                //alert("Bitte aktivieren Sie GPS um Ihren Location zu finden");

            } else if( err.code == 2) {
                alert(err[1]);
                //alert("Ihre aktuelle Position ist nicht verfügbar, probieren Sie es später noch einmal");
                error = true;

            }
        },

        // get the customer current location
        // @todo: I18N this
        getCurrentLocation: function(errorString) {

            if(navigator.geolocation) {

                  // timeout at 60000 milliseconds (60 seconds)
                  var options = { timeout: 60000 };

                  navigator.geolocation.getCurrentPosition(module.showLocation, module.errorHandler, options);

            } else {

                //alert("Ihr Browser unterstützt leider kein GPS");
                alert(errorString);

            }

        },

        smoothZoom: function(level, cnt, mode, marker) {

            var maxZoomOut = module.extraOptions.maxZoomOut,
                maxZoomIn = module.extraOptions.maxZoomIn;

            if(mode == true) {

                if (cnt >= level) {
                    return;
                } else {

                    if((maxZoomOut + 2) <= cnt) {

                        var z = google.maps.event.addListener(module.map, 'zoom_changed', function(event) {

                            google.maps.event.removeListener(z);
                            // module.map.setCenter(marker.getPosition());
                            module.smoothZoom(level, cnt + 1, true,marker);

                        });

                        setTimeout(function(){module.map.setZoom(cnt);}, 200);

                    } else {

                        module.map.setZoom(cnt);
                        module.smoothZoom( level, cnt + 1, true,marker);

                    }

                }

            } else {

                if (cnt < level) {
                    return;
                } else {

                    var z = google.maps.event.addListener(module.map, 'zoom_changed', function(event) {

                        google.maps.event.removeListener(z);
                        module.map.panTo(marker.getPosition());
                        module.smoothZoom(level, cnt - 1, false,marker);

                    });

                    if(maxZoomIn - 2 <= cnt) {

                        module.map.setZoom(cnt);

                    } else {

                        setTimeout(function(){module.map.setZoom(cnt);}, 200);

                    }

                }

            }

        },

        setOptions: function(options) {
            module.map.setOptions(options);
        }

    }

    mbiConfig.modules.GoogleMaps = true;

    return module;

});
